document.addEventListener("DOMContentLoaded", function() {

    paramHeight();

    window.addEventListener("resize", () => {
        paramHeight();
    })

});

export default function paramHeight(){

    if(window.innerWidth >= 990){
        const wrapper = document.querySelectorAll(".js-features-table");

        if(wrapper.length > 0){

            wrapper.forEach(function(el){

                const row = el.querySelectorAll(".tr"),
                    wrapperTable = el.closest(".js-params-wrap"),
                    wrapperParams = wrapperTable.querySelector(".js-params-table");

                row.forEach(function(el, i){

                    let height = el.offsetHeight;

                    wrapperParams.querySelectorAll(".param")[i].style.height = height+ "px";
                });
            });
        }
    }
}